export const MESSAGES = {
    PLAN_DETAILS: {
        CHEFS_NOTES_TITLE: "Chef's Notes",
    }
};
